import { createElement, memo, useMemo } from 'react';

import { emptyObject } from 'Lib/constants/placeholder';
import shallowEqualNested from 'Lib/utils/shallowEqualNested';

import { I13nModel } from './types';

export const makePure = <
  TComponent extends React.ElementType,
  TComponentProps = React.ComponentProps<TComponent>
>(
  I13nComponent: TComponent,
  i13nBase: I13nModel = {}
): TComponent => {
  const I13nSCUComponent = (props: TComponentProps & { i13nModel?: I13nModel }) => {
    const { i13nModel = emptyObject, ...rest } = props;
    const normalizedModel = useMemo(
      () => ({
        ...i13nBase,
        ...i13nModel,
      }),
      [i13nModel]
    );

    return createElement(I13nComponent, {
      ...rest,
      i13nModel: normalizedModel,
    });
  };

  return memo(I13nSCUComponent, (prev, next) =>
    shallowEqualNested(prev, next, ['children', 'i13nModel'])
  ) as unknown as TComponent;
};
